import gql from 'graphql-tag';

export default gql`
mutation deleteImageById($image_id: Int!) {
  delete_images_by_pk(image_id: $image_id) {
    image_id
  }
}
`;
